<template>
    <div>
        <b-button
            variant="warning"
            @click.stop="mostrarModal = true"
            class="float-right"
            :disabled="percentualDisponivel < 0.00001"
        >
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Dotação Orçamentária
            </span>
        </b-button>
        <inserir-atualizar-dotacao-em-massa-form
            acao="INSERIR"
            :mostrarModal="mostrarModal"
            @modalFechado="mostrarModal = false"
            :percentualTotal="percentualTotal"
            :percentualDisponivel="percentualDisponivel"
            @inserirRateio="$emit('inserirRateio', $event)"
            @obterUnidades="$emit('obterUnidades')"
            @obterProjetos="$emit('obterProjetos', $event)"
            @obterAcoes="$emit('obterAcoes', $event)"
            :unidades="unidades"
            :projetos="projetos"
            :acoes="acoes"
        ></inserir-atualizar-dotacao-em-massa-form>
    </div>
</template>

<script>
import InserirAtualizarDotacaoEmMassaForm from './InserirAtualizarDotacaoEmMassaForm'

export default {
    props: {
        percentualTotal: {
            type: Number,
            default: () => 0
        },

        percentualDisponivel: {
            type: Number,
            default: () => 0
        },

        unidades: {
            type: Array
        }, 

        projetos: {
            type: Array
        }, 
        
        acoes: {
            type: Array
        }
    },

    data() {
        return {
            mostrarModal: false
        }
    },

    components: {
        InserirAtualizarDotacaoEmMassaForm
    }
}

</script>